import { deserialize, deserializeAs, inheritSerialization } from 'cerialize';
import { Entity } from './entity';

@inheritSerialization(Entity)
export class Nuisance extends Entity {

  @deserialize
  termites;

  @deserialize
  amiante;

  @deserialize
  plomb;
}
